import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Stepper,
  Step,
  StepLabel,
} from "@mui/material";
import { DoubleArrow } from "@mui/icons-material";
import { themes } from "services/constants";
import { BasicInfo } from "../Component/BasicInfo";
import { Earning } from "../Component/Earning";
import { Deductions } from "../Component/Deductions";
import { Preview } from "../Component/Preview";
import { Adjustment } from "../Component/Adjustment";
import { AnimatedConnector } from "components/CustomComponents/Stepper";
import { CustomSftCategoryStepIcon } from "../Component/ShiftCategoryOptions";
import { steps } from "../Component/ShiftCategoryOptions";

export const CreateShiftCategory = ({
  onClose,
  reCallApi,
  setHandleLoader,
  complianceData,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [clearAbsenceValues, setClearAbsenceValues] = useState(false);
  const [formData, setFormData] = useState({
    basic: {},
    adjustment: {},
    earning: {},
    deductions: {},
  });
  const handleNext = (value) => {
    setActiveStep(value);
  };

  const handleBack = (value) => {
    setActiveStep(value);
  };

  const handleDataUpdate = (step, data) => {
    setFormData((prev) => ({
      ...prev,
      [step]: { ...prev[step], ...data },
    }));
  };

  const renderStepContent = (activeStep) => {
    switch (activeStep) {
      case 0:
        return (
          <BasicInfo
            data={formData.basic}
            onUpdate={(data) => handleDataUpdate("basic", data)}
            handleNext={handleNext}
            isEditScreen={false}
            showCategoryName={false}
          />
        );
      case 1:
        return (
          <Earning
            data={formData.earning}
            complianceData={complianceData}
            onUpdate={(data) => handleDataUpdate("earning", data)}
            handleBack={handleBack}
            handleNext={handleNext}
            clearAbsenceValues={clearAbsenceValues}
            setClearAbsenceValues={setClearAbsenceValues}
          />
        );
      case 2:
        return (
          <Deductions
            data={formData.deductions}
            earningData={formData.earning}
            complianceData={complianceData}
            onUpdate={(data) => handleDataUpdate("deductions", data)}
            handleBack={handleBack}
            handleNext={handleNext}
            sftPenaltyPolicy={
              formData?.basic?.payment_based_on === "Working Hours" ||
              formData?.basic?.payment_based_on === "Partial Shift Credit"
            }
            isAbsencePaid={formData?.earning?.is_absence_paid}
            setClearAbsenceValues={setClearAbsenceValues}
          />
        );
      case 3:
        return (
          <Adjustment
            data={formData.adjustment}
            earningData={formData.earning}
            deductionsData={formData.deductions}
            complianceData={complianceData}
            onUpdate={(data) => handleDataUpdate("adjustment", data)}
            handleBack={handleBack}
            handleNext={handleNext}
            clearAbsenceValues={clearAbsenceValues}
            setClearAbsenceValues={setClearAbsenceValues}
            paymentBasedOn={formData.basic?.payment_based_on}
          />
        );
      case 4:
        return (
          <Preview
            basicInfoData={formData.basic}
            earningData={formData.earning}
            deductionsData={formData.deductions}
            adjustmentData={formData.adjustment}
            clearAbsenceValues={clearAbsenceValues}
            complianceData={complianceData}
            sftPenaltyPolicy={
              formData?.basic?.payment_based_on === "Working Hours" ||
              formData?.basic?.payment_based_on === "Partial Shift Credit"
            }
            handleBack={handleBack}
            handleNext={handleNext}
            onClose={onClose}
            reCallApi={reCallApi}
            isEditScreen={false}
            isCreateScreen={true}
            isPreview={false}
            setHandleLoader={setHandleLoader}
          />
        );
      default:
        return "Unknown step";
    }
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          borderBottom: `1px solid ${themes?.miliedLightGray}`,
          borderRadius: 0,
        }}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          sx={{ padding: 1, backgroundColor: themes?.primary }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderRadius: "50%",
            }}
          >
            <Box sx={{ ml: 1 }}>
              <IconButton
                onClick={onClose}
                sx={{
                  color: themes?.grayColor,
                  "&:hover": {
                    backgroundColor: themes?.whiteColor,
                  },
                }}
              >
                <DoubleArrow />
              </IconButton>
            </Box>
          </Box>

          <Box sx={{ ml: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Create Shift Category
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Defines earnings and deductions for salary calculation
            </Typography>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ flexGrow: 1, overflow: "auto" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ mt: 3 }}>
            <Stepper
              activeStep={activeStep}
              alternativeLabel
              connector={<AnimatedConnector />}
              sx={{ mb: 2 }}
            >
              {steps.map((step, index) => (
                <Step key={step.label}>
                  <StepLabel
                    StepIconComponent={CustomSftCategoryStepIcon}
                    sx={{
                      "& .MuiStepLabel-label.Mui-active": {
                        color: "#00D4AA",
                        fontWeight: "bold",
                      },
                      "& .MuiStepLabel-label.Mui-completed": {
                        color: "#00D4AA",
                      },
                    }}
                  >
                    {step.label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
          <Box
            sx={{
              borderBottom: `1px solid ${themes?.miliedLightGray}`,
              borderRadius: 0,
            }}
          ></Box>
          <Box>{renderStepContent(activeStep)}</Box>
        </Box>
      </Box>
    </Box>
  );
};
